import React from 'react';

import {TAG_COLORS} from '../../../../consts/notifications/notifications';

const TagList = ({selectedTag, categoryCounts = {}, onTagClick}) => {
    const tagNames = Object.keys(TAG_COLORS);

    return (
        <div className='flex flex-wrap gap-2 w-full'>
            {tagNames.map((tagName) => {
                const tagColor = TAG_COLORS[tagName];
                const isSelected = selectedTag === tagName;

                return (
                    <button
                        type='button'
                        aria-pressed={isSelected}
                        key={tagName}
                        onClick={() => onTagClick(tagName)}
                        style={{
                            '--tag-color': tagColor,
                            '--tag-shadow': `${tagColor}66`,
                        }}
                        className={`
                            notification-category-tag flex items-center justify-center
                            px-3 py-1.5 rounded-full border
                            text-12 font-medium
                            transition-all duration-200
                            cursor-pointer select-none
                            ${
                                isSelected
                                    ? 'bg-[var(--tag-color)] text-white border-[var(--tag-color)] shadow-[0_4px_10px_-2px_var(--tag-shadow)]'
                                    : 'bg-white text-zambezi border-whisper hover:bg-solitude hover:text-charcoal'
                            }
                        `}
                    >
                        <span
                            className={`
                                flex-shrink-0 w-1.5 h-1.5 rounded-full mr-1.5 transition-colors duration-200
                                ${isSelected ? 'bg-white opacity-90' : 'bg-[var(--tag-color)] opacity-100'}
                            `}
                        />

                        <span className='truncate tracking-01'>{tagName}</span>
                        <span className='notification-category-count' data-empty={!categoryCounts[tagName]}>
                            {categoryCounts[tagName] || 0}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default TagList;
